// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"ffefc0a3","245":"ffefc0a3","976":"f4759343"}[chunkId] + ".chunk.css";
};